var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('main',{staticClass:"pt-4 pb-0",attrs:{"id":"main"}},[_c('router-view')],1),_c('DpFooter',{attrs:{"base-url":_vm.getBaseUrl || _vm.fallbackBaseUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }